export default "__VITE_ASSET__DOem$M5q__"